// extracted by mini-css-extract-plugin
export default {"container":"Cr-z","heading":"Dr-z","text":"Er-z","info":"Fr-z","link":"Gr-z","fullMaxWidth":"Hr-z"};